/**
 * Constantes portadas do legado ([application.js:11,123,144,164] etc.).
 */

/** Limite padrão de tags/segmentos na captura. Legado: `tagLimit` (sobrescrito por /me). */
export const TAG_LIMIT_DEFAULT = 10;

/** Timeout de "servidor offline" em ms. Legado: `serverStatusTimeout`. */
export const SERVER_STATUS_TIMEOUT = 15000;

/** Tamanho de página das requisições de leads/places. Legado: chunks de 1000. */
export const PAGE_SIZE = 1000;

/** Idiomas suportados pelo painel. */
export const SUPPORTED_LANGS = ['pt', 'en', 'es', 'fr'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

/** Módulos de captura / listas. */
export const LIST_MODULES = ['emails', 'phones', 'places', 'hunter'] as const;
export type ListModule = (typeof LIST_MODULES)[number];

/**
 * Módulos que o painel mostra e deixa capturar. O Hunter (contatos profissionais pelo LinkedIn)
 * saiu do painel em 17/10/2026, a pedido do Marcelo: segue nos tipos só para ler listas e
 * mensagens antigas da extensão.
 */
export const VISIBLE_LIST_MODULES: readonly ListModule[] = ['places', 'phones', 'emails'];

export function isVisibleListModule(value: unknown): value is ListModule {
  return typeof value === 'string' && (VISIBLE_LIST_MODULES as readonly string[]).includes(value);
}
